import React from 'react'
import Img from "gatsby-image";

import HeroSmall from '../components/HeroSmall'
import LocationMicroNav from '../components/LocationMicroNav'
import LocationContent from '../components/LocationContent'
import LocationRelated from '../components/LocationRelated'

class WashingtonDCLocation extends React.Component {
  render() {
    return (
      <div>
        <HeroSmall location="Washington, DC" />
        <LocationMicroNav />

        { /* WashingtonDC, Story 1 */ }
        <LocationContent 
          category="Bike Biz" 
          title="The Best Fest"
          story='Our first-ever Congressional Bike Fest in Washington, D.C. welcomed more than 400 congressional staffers and showcased the best of the U.S. bike industry in the Rayburn Building of the U.S. House of Representatives. Twenty-two brands showcased their latest products. We featured items from Accell, ASI, Bell, blackriver, Bosch, CamelBak, Capital Bikeshare, CSG, Huffy, Giant, Giro, J&B, Pure Cycle, QBP, REI, Saris, Shimano, Shinola, Specialized, SRAM, Trek and WTB. "We are an industry of innovation, job creation and mobility," says Rebecca Smith, general manager of REI’s Washington, D.C. flagship store. "The Bike Fest was an opportunity to remind elected officials how innovative our industry is and how influential and important the $887 billion outdoor industry is to local economies. Our showcase brought out Hill staffers and members of Congress who appreciate the power of bikes and understand their value to communities across the nation."'
        />
        <Img
          title="WashingtonDC 1-1"
          alt="Congressional Bike Fest Pic"
          sizes= { this.props.data.washingtonDCOneOneImage.sizes }
        />

        { /* WashingtonDC, Story 2 */ }
        <LocationContent 
          category="Govt—Federal" 
          title="Management Assist"
          story="We convened the first stakeholder e-bike meeting of officials from key federal agencies including the Bureau of Land Management, National Park Service, and United States Forest Service to discuss a coordinated approach to managing e-bikes on federal lands. Our goal for the group is to identify and implement both short-term and long-term policy solutions. The conference highlighted innovative approaches regarding data, managing demand, working with partners, and physical impacts on sensitive resources. We brought together professionals from federal land management and transportation agencies, state and local transportation and transit agencies, universities, consulting firms, foundations, and non-profit groups."
        />
        <Img
          title="WashingtonDC 2-1"
          alt="Federal Agency Meetings"
          sizes= { this.props.data.washingtonDCTwoOneImage.sizes }
        />
        
        { /* WashingtonDC, Story 3 */ }
        <LocationContent 
          category="Research" 
          title="Talking with the Top"
          story="Transportation Research Board (TRB): This annual conference attracts 10,000 of the best and brightest worldwide minds doing transportation research. The TRB committee that is dedicated to bicycle transportation includes the top bicycle researchers and determines the research agenda for the field. We had the opportunity to talk about the Big Jump and PlacesForBikes and describe all of the new data resources we are creating."
        />    
        <Img
          title="WashingtonDC 3-1"
          alt="Transportation Research Board"
          sizes= { this.props.data.washingtonDCThreeOneImage.sizes }
        />

        { /* WashingtonDC, Story 4 */ }
        <LocationContent 
          category="Bike Biz" 
          title="Creating Partnerships"
          story='Continuing a strong year for bike industry presence in Washington, D.C., PeopleForBikes brought together 10 leaders for a women’s executive fly-in from October 17-19. The executives visited their members of Congress for meetings focused on TIGER and TAP—two programs that help build bicycle infrastructure and have come under attack in Congress. "Federal investment in bike infrastructure helps our local governments build more places for bikes," said Amelia Kegel, marketing manager for Wisconsin retailer Wheel & Sprocket. "With more great and safe places to ride we can grow ridership and create more opportunities for our shops to expand and contribute to our local economy." Attendees of the fly-in included Taldi Walter, REI; Jessica Grenwis, Quality Bicycle Products; Isabella Burczak, Union Cycliste Internationale; Milissa Rick, Pacific Cycles; Stephanie Kaplan, Specialized; Jennifer Naeger, Trek; Milay Galvez, Advanced Sports International; Megan Duehring, Felt; Tracy Cameron, Shimano; and Amelia Kegel, Wheel & Sprocket.'
        />     
        <Img
          title="WashingtonDC 5-1"
          alt="PFB Staff in DC"
          sizes= { this.props.data.washingtonDCFiveOneImage.sizes }
        />          


        { /* WashingtonDC, Story 5 */ }
        <LocationContent 
          category="Promoting Ridership" 
          title="It's a Small World After All"
          story="The United Nations, World Health Organization, World Bank and other major global organizations have the resources, networks, and capacity to help increase and improve bicycling around the world. PeopleForBikes is a founding member of The World Cycling Alliance—a streamlined, focused organization that shares bicycling best practices and summarizes the benefits of bicycling to these international groups and to government leaders worldwide. The WCA was launched four years ago by our partner, the European Cyclists' Federation. PeopleForBikes hosted a World Cycling Alliance board meeting in Washington, DC, in January 2017."
        />   
        <Img
          title="WashingtonDC 4-1"
          alt="PFB Partnerships"
          sizes= { this.props.data.washingtonDCFourOneImage.sizes }
        />   

        { /* WashingtonDC, Story 6 */ }
        <LocationContent 
          category="Bike Biz" 
          title="The Great Outdoors"
          story="The Outdoor Industry Association’s Capitol Summit is an opportunity for industry executives from across the nation to visit Washington D.C. and educate their elected officials in Congress on key issues related to their businesses. At the 2017 event, more than 130 attendees, including two members of PeopleForBikes staff, had the opportunity to connect with agency, administration and elected officials. It was also a chance to build valuable relationships with peers. "
        /> 

        <LocationRelated 
          prevLocationName="Montana"
          prevLocationPath="montana"
          prevLocationImgPath= { this.props.data.washingtonDCPrevImage }
          nextLocationName="Wisconsin"
          nextLocationPath="wisconsin"
          nextLocationImgPath= { this.props.data.washingtonDCNextImage }
        /> 
      </div>
    )
  }
}

export default WashingtonDCLocation 

// GraphQL queries for each image, got to be a better way to do this but whatever for now
export const WashingtonDCImageQuery = graphql`
  query WashingtonDCImageQuery {
    washingtonDCOneOneImage: imageSharp(id: { regex: "/PFB_DC_1-1/" }) {
      sizes(maxWidth: 1600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },
    washingtonDCTwoOneImage: imageSharp(id: { regex: "/PFB_DC_2-1/" }) {
      sizes(maxWidth: 1600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },
    washingtonDCThreeOneImage: imageSharp(id: { regex: "/PFB_DC_3-1/" }) {
      sizes(maxWidth: 1600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },
    washingtonDCFourOneImage: imageSharp(id: { regex: "/PFB_DC_4-1/" }) {
      sizes(maxWidth: 1600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },
    washingtonDCFiveOneImage: imageSharp(id: { regex: "/PFB_DC_5-1/" }) {
      sizes(maxWidth: 1600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },    
    washingtonDCPrevImage: imageSharp(id: { regex: "/PFB_MONTANA/" }) {
      sizes(maxWidth: 600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },
    washingtonDCNextImage: imageSharp(id: { regex: "/PFB_WISCONSIN/" }) {
      sizes(maxWidth: 600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/washington-dc.js